var MDB = window.MDB || {};;
MDB.TaskScheduler = MDB.TaskScheduler || {};

(function() {

    var _config,
        _details,
        _editor,
        _newTaskTitle,
        _editTaskTitle
    ;

    $.extend(MDB.TaskScheduler, {
    	boot: function (config) {
    		_config = config;
    		_details = $("#taskDetails");
    		_editor = $("#task-editor");
            _newTaskTitle = '<i class="fa fa-plus text-success"></i> ' + MDB.loadResourceString('ScheduledTasks_Create_Task_Header');
            _editTaskTitle = '<i class="fa fa-pencil text-warning"></i> ' + MDB.loadResourceString('ScheduledTasks_Edit_Task_Header');
    		
    		
    		initTreeView();

	        setEditClickHandler();
            setCloneClickHandler();
            setCreateClickHandler();
	        setSaveClickHandler();
	        setConfigKeyHandlers();
            setExpandCollapseKeyHandlers();
    	}
    });

    function appendDeleteButtons() {
    	var template = $('<a href="javascript:void(0)" class="pull-right mdb-icon-btn delete" data-role="delete"><i class="fa fa-trash-o"></i></a>');

    	$('[data-role="task"]').each(function () {
    		var item = $(this);
    		template.clone().insertAfter(item);

    		item.next().hover(function() {
    			item.addClass('k-treeview-delete');
    		});

    		item.next().mouseleave(function() {
    			item.removeClass('k-treeview-delete');    			
    		});
    	});

    	setDeleteClickHandler();
    }

    function setDeleteClickHandler() {
	    $('[data-role="delete"]').click(function (e) {
	    	var me = $(this);
	    	var id = me.prev().data('id');

	    	MDB.promptWithIcon(
	    		MDB.loadResourceString('ScheduledTasks_Delete_Task_Title'),
	    		MDB.loadResourceString('ScheduledTasks_Delete_Task_Body'), 
	    		'fa fa-trash-o text-danger', 
	    		function(ok) {
	    			if(ok) {
		    			MDB.sendAjaxRequest(_config.deleteUrl, {id: id}, 'POST').done(function (response) {
		    				if(response.success) {
		    					MDB.Notify.bootstrapSuccess(MDB.loadResourceString('ScheduledTasks_Delete_Task_Success_Message'));
	    				        
                                var parents = me.parents('[role="treeitem"]');
                                me.closest('[role="treeitem"]').remove();
                                
                                parents.each(function () {
                                    var parent = $(this);
                                    
                                    if(parent.children('ul').length == 0 || parent.children('ul').children().length == 0) {
                                        parent.remove();
                                    }
                                });

		    					_details.empty();
		    				}
		    			});
	    			}
	    		});
   			});
    }

    function setEditClickHandler() {
        $('#taskDetails').on('click', '[data-action="edit-task"]', function(e) {
            var button = $(this);
            
            loadTaskEditor(
                _config.editUrl + '/' + button.data('id'),
                _editTaskTitle
            );
	    });
    }
    
    function setCloneClickHandler(){
        $('#taskDetails').on('click', '[data-action="clone-task"]', function(){
            var button = $(this);

            loadTaskEditor(
                _config.cloneUrl + '/' + button.data('id'),
                _newTaskTitle
            );
        });
    }

    function setCreateClickHandler() {
    	$('#create-task').click(function(e) {
            loadTaskEditor(
                _config.createUrl, 
                _newTaskTitle
            );
        });
    }
    
    function loadTaskEditor(url, title){
        _editor.find('.modal-title').html(title);

        var body = _editor.find('.modal-body');
        body.load(url, function () {
            _editor.modal('show');
            setCronDescUpdateHandler(body);
        });
    }

    function setCronDescUpdateHandler(selector) {
        var schedule = selector.find('#Schedule');

        schedule.blur(function () {          
            MDB.sendAjaxRequest(_config.getCronDescUrl + '?cron=' + schedule.val()).done(function (response) {
                var cron = response.value;
                $('#cron-desc').html(cron);
            });
        });
    }

    function setSaveClickHandler() {
        $('[data-action="editor-save"]').click(function () {
        	var form = _editor.find('form');
        	var config = form.find('#Config');
        	
        	if(config.val() == '') {
                config.val('{}');
            }

        	if(form.valid()) {
    			MDB.sendAjaxRequest(form.attr('action'), form.serializeToJSON(), form.attr('method')).done(function (response) {
	        		if(response.success) {
	        			_editor.modal('hide');
	        			MDB.Notify.bootstrapSuccess(MDB.loadResourceString('ScheduledTasks_Save_Task_Success_Message'));
	        			reloadTasks(response.value.Id);
	        		}
        		});
        	}
        });
    }

    function setConfigKeyHandlers() {
        $('body').on('keydown', '#Config', function(e) {
		 	if(e.keyCode === 9) {
        		e.preventDefault();
        		var me = $(this);

			    var cursorPos = me.prop('selectionStart');
			    
			    var text = me.val();
			    var textBefore = text.substring(0,  cursorPos);
			    var textAfter  = text.substring(cursorPos, text.length);

			    me.val(textBefore + '\t' + textAfter);
			    me.prop('selectionEnd', me.val().length - textAfter.length);
        	}
        });

        $('body').on('keyup', '#Config', function(e) {
		 	if(e.keyCode === 13) {
        		var me = $(this);

			    var cursorPos = me.prop('selectionStart');

			    var text = me.val();
			    var textBefore = text.substring(0,  cursorPos);
			    var textAfter  = text.substring(cursorPos, text.length);

			    var lines = textBefore.split('\n');
			    var tabCount = countTabs(lines[lines.length-2]);
			    var tabs = insertTabs(tabCount);

			    me.val(textBefore + tabs + textAfter);
			    me.prop('selectionEnd', me.val().length - textAfter.length);
        	}
        });
    }

    function setExpandCollapseKeyHandlers() {
        $('#expand-all').click(function () {
            expandAll();
        });

        $('#collapse-all').click(function () {
            collapseAll();
        });
    }

    function countTabs(str) {
    	var count = 0;
    	
        for (var i = 0; i < str.length; i++) {
		  if(str.charAt(i) == '\t') {
    			count++;
    		} else {
    			return count;
    		}
        }
        return count;
    }

    function insertTabs(number) {
    	var tabs = "";
    	for(var i = 0 ; i < number ; i++) {
    		tabs = tabs + '\t';
    	}
    	return tabs;
    }

    function reloadTasks(selectedId) {
        $('#all-tasks').load(_config.getTasksUrl, function() {
            initTreeView();
			
            if(selectedId) {
                var task = $('[data-role="task"][data-id="'+selectedId+'"]');

                $(task.parents('[role="treeitem"]').get().reverse()).each(function () { 
                    var me = $(this);

                    me.children('.k-mid,.k-bot').children('.k-plus').click();
                    task.click();
                });
            }
        });
    }

    function initTreeView() {
        var spinner = $('#load-spinner');
        var container = $('#tree-container');
        var tree = $("#treeview");
                
        spinner.show();
        container.hide();

        tree.kendoTreeView();
        
        $('[data-role="task"]').click(function(e) {
        	var id = $(this).data('id');
        	loadDetails(id);
        });

        tree.find('span').click(function () {
            var me = $(this);
            var sibling = me.prev();

            if(sibling.hasClass('k-plus')) {
                sibling.click();
            }
        });

    	appendDeleteButtons();

        container.show();
        spinner.hide();
    }

    function collapseAll() {
        var tree = $("#treeview").data('kendoTreeView');
        tree.collapse('.k-item');
    }

    function expandAll() {
        var tree = $("#treeview").data('kendoTreeView');
        tree.expand('.k-item');
    }

    function loadDetails(id) {
        var partial = _config.detailsUrl + '/' + id;
        _details.load(partial);
    }

})();